//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('shopFloorSelectOh', {
//        templateUrl: 'views/components/views/shopFloorSelectOh/shopFloorSelectOh.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'utilityService', 'shopFloorSelectOhService', 'logisticService', 'labourPositionService', 'operationFactoryService', 'rememberService', 'ttGridFactory', function (stateService, utilityService, shopFloorSelectOhService, logisticService, labourPositionService, operationFactoryService, rememberService, ttGridFactory) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;

//            let variableNames = {
//                businessco_no: '',
//                factory_id: '',
//                operation_id: '',
//                equipment_id: '',
//                group_by_component: ''
//            };

//            vm.model = {
//                operationButtons: [
//                    { id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => reset('operation_id') }
//                ],
//                equipmentButtons: [
//                    { id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => reset('equipment_id') }
//                ],
//                setting: {},
//                selectListCompanies: [],
//                selectListFactories: [],
//                selectListOperations: [],
//                selectListEquipments: []
//            };

//            vm.grid = new ttGridFactory({
//                rememberId: 'w_shopfloorselectoh_grid',
//                kendo: {
//                    height: '100%',
//                    sortable: true,
//                    aggregate: true,
//                    pager: false,
//                    selectable: false,
//                    filterable: false
//                }
//            });
            
//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadSetting() {
//                vm.model.setting = (await shopFloorSelectOhService.getSetting())[0];

//                Promise.all([
//                    loadFactories(),
//                    loadOperations(),
//                    loadSelectEquipments()
//                ]).then(() => {
//                    loadGrid();
//                    Promise.resolve();
//                });
//            }

//            async function loadCompanies() {
//                vm.model.selectListCompanies = await logisticService.listCompanies();
//            }

//            async function loadFactories() {
//                if (utilityService.validateParmsValue(vm.model.setting.businessco_no, true) !== true) return;

//                vm.model.selectListFactories = await labourPositionService.listSelectFactories({ businessco_no: vm.model.setting.businessco_no });
//            }

//            async function loadOperations() {
//                if (utilityService.validateParmsValue(vm.model.setting.factory_id, true) !== true) return;

//                vm.model.selectListOperations = await logisticService.listOperations({
//                    direct: '1',
//                    factory_id: vm.model.setting.factory_id
//                });
//            }

//            async function loadSelectEquipments() {
//                if (utilityService.validateParmsValue(vm.model.setting.factory_id, true) !== true) return;
//                if (utilityService.validateParmsValue(vm.model.setting.operation_id, true) !== true) return;

//                vm.model.selectListEquipments = await operationFactoryService.listSelectEquipments({
//                    workgrp_keyno: '0',
//                    factory_id: vm.model.setting.factory_id,
//                    operation_id: vm.model.setting.operation_id
//                });
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region GRID PROCEDURE FUNCTION CALLS

//            async function loadGrid() {
//                vm.grid.dataTask.loadData = {
//                    method: 3812,
//                    parameters: vm.model.setting
//                };

//                vm.model.gridReady = true;

//                if (vm.grid.gridfunc !== null) vm.grid.gridfunc.read();
//            }

//            // #endregion GRID PROCEDURE FUNCTION CALLS

//            // #region REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//            function rememberFunc(id) {
//                Object.keys(variableNames).forEach((key) => {
//                    variableNames[key] = 'w_shopfloor' + '.' + key;
//                });

//                if (utilityService.validateParmsValue(variableNames[id]) !== true) return;

//                let variableValue = null;

//                switch (id) {
//                    case 'businessco_no':
//                    case 'factory_id':
//                    case 'operation_id':
//                    case 'equipment_id':
//                    case 'group_by_component':
//                        if (utilityService.validateParmsValue(vm.model.setting[id], true) !== true) return;

//                        variableValue = vm.model.setting[id];
//                        break;
//                    default:
//                        break;
//                }

//                return rememberService.remember(variableNames[id], variableValue);
//            }

//            // #endregion REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//            // #region RESET BUTTON FUNCTION

//            function reset(id) {
//                switch (id) {
//                    case 'operation_id':
//                    case 'equipment_id':
//                        vm.model.setting[id] = '';

//                        if (vm.model.setting[id] === '') {
//                            Promise.all([
//                                rememberFunc(id)
//                            ]).then(() => {
//                                loadGrid();
//                                Promise.resolve();
//                            });
//                        }
//                        break;
//                    default:
//                        break;
//                }
//            }

//            // #endregion RESET BUTTON FUNCTION

//            // #region FIELD CHANGE MULTI FUNCTIONS

//            vm.onChanged = function (value, id) {
//                switch (id) {
//                    case 'businessco_no':
//                        if (utilityService.validateWatchValue(value, vm.model.setting.businessco_no) !== true) return;

//                        vm.model.setting.businessco_no = value;

//                        if (utilityService.validateParmsValue(vm.model.setting.businessco_no) !== true) return;

//                        Promise.all([
//                            rememberFunc('businessco_no'),
//                            loadFactories()
//                        ]).then(() => {
//                            loadGrid();
//                            Promise.resolve();
//                        });
//                        break;
//                    case 'factory_id':
//                        if (utilityService.validateWatchValue(value, vm.model.setting.factory_id) !== true) return;

//                        vm.model.setting.factory_id = value;

//                        if (utilityService.validateParmsValue(vm.model.setting.factory_id, true) !== true) return;

//                        Promise.all([
//                            rememberFunc('factory_id'),
//                            loadOperations(),
//                            loadSelectEquipments()
//                        ]).then(() => {
//                            loadGrid();
//                            Promise.resolve();
//                        });
//                        break;
//                    case 'operation_id':
//                        if (utilityService.validateWatchValue(value, vm.model.setting.operation_id) !== true) return;

//                        vm.model.setting.operation_id = value;

//                        if (utilityService.validateParmsValue(vm.model.setting.operation_id, true) !== true) return;

//                        Promise.all([
//                            rememberFunc('operation_id'),
//                            loadSelectEquipments()
//                        ]).then(() => {
//                            loadGrid();
//                            Promise.resolve();
//                        });
//                        break;
//                    case 'equipment_id':
//                        if (utilityService.validateWatchValue(value, vm.model.setting.equipment_id) !== true) return;

//                        vm.model.setting.equipment_id = value;

//                        if (utilityService.validateParmsValue(vm.model.setting.equipment_id, true) !== true) return;

//                        Promise.all([
//                            rememberFunc('equipment_id')
//                        ]).then(() => {
//                            loadGrid();
//                            Promise.resolve();
//                        });
//                        break;
//                    case 'group_by_component':
//                        if (utilityService.validateWatchValue(value, vm.model.setting.group_by_component) !== true) return;

//                        vm.model.setting.group_by_component = value;

//                        if (utilityService.validateParmsValue(vm.model.setting.group_by_component, true) !== true) return;

//                        Promise.all([
//                            rememberFunc('group_by_component')
//                        ]).then(() => {
//                            loadGrid();
//                            Promise.resolve();
//                        });
//                        break;
//                    default:
//                        utilityService.setValueToVariable(value);
//                        break;
//                }
//            };

//            // #endregion FIELD CHANGE MULTI FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//            	loadSetting();
//                loadCompanies();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
